export default __webpack_public_path__ + "static/media/carFleets.aa4623da.svg";